// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_aw0","icon":"styles_icon__x9P1Z"};